<app-dialog
  #dialog
  [key]="'unlink-meeting-deal'"
  [action]="'unlink-meeting-deal'"
  [headerTheme]="'simple'"
  [title]="'Desvincular de um deal'"
  [maxWidth]="'560px'">
  <div class="unlink-meeting">
    @if (ligacao(); as meeting) {
      <p class="unlink-meeting__meeting">
        <strong>{{ meeting.title }}</strong>
        <span>{{ meeting.scheduledStartAt | vaultDateTime }}</span>
      </p>
    }

    <app-select
      [label]="'Deal'"
      [placeholder]="'Selecione o deal a desvincular'"
      [options]="opcoes()"
      [(ngModel)]="dealSelecionado" />

    <p class="unlink-call__hint">
      A reunião deixa de aparecer na aba Reuniões do deal escolhido, para todos que o veem. Ela
      continua aqui e pode ser vinculada de novo.
    </p>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="fechar()" />
      <app-button
        [label]="'Desvincular'"
        [theme]="'danger'"
        [disabled]="!isFormValid()"
        [isLoading]="gravando()"
        [loadingText]="'Desvinculando...'"
        [type]="'button'"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
